import { Button, LabelSmall } from "@mezo-org/mezo-clay"

import { links } from "#/shared/constants"

export default function DashboardHeaderExplorer() {
  return (
    <Button
      shape="pill"
      size="small"
      kind="secondary"
      $as="a"
      href={links.BLOCK_EXPLORER}
      target="_blank"
    >
      <LabelSmall>Block explorer</LabelSmall>
    </Button>
  )
}
